import { nextHour } from '../../../../../../../../../../../../Resource/FormTemplates/Inputs/DateTimeInput/Time';
import {
  FormTemplate,
  fieldValue,
} from '../../../../../../../../../../../../Resource/FormTemplates/Types';
import { LearningCollectionPublishResource } from '../../../../../Store/Types';

const fieldDate = (template: FormTemplate): Date =>
  fieldValue('send_email_date', 'date', template).getOrElseValue(nextHour());

export const learningCollectionInvitationsEncoder = (
  timeZone: string,
  template: FormTemplate,
  resource: LearningCollectionPublishResource,
  userIds: number[],
  groupIds: number[],
  skipCommunications: boolean,
) => ({
  use_case_id: resource.payload.id,
  user_ids: userIds,
  group_ids: groupIds,
  send_email_date: new Date(
    fieldDate(template).toLocaleString('en-US', { timeZone: timeZone }),
  ).toISOString(),
  skip_communications: skipCommunications,
});
